import { mdiTextAccount } from '@mdi/js'

export default {
  title: 'E-Voting Kelas',
  to: 'evoting-teacher-list',
  icon: mdiTextAccount,
  resource: 'EvotingTeacher',
  action: 'read',
}
